define ['./whyModal.css', './bank_account_info.css'], () ->
  ($scope, $state, $stateParams, RentappService, $uibModal, hotkeys, Account, Flash) ->
    $scope.secure_svg = require('./../secure.svg')
    $scope.account_type_map =
      individual: 'Individual'
      company: 'Company'

    $scope.account_settings = $stateParams.account_settings or {}

    $scope.states = ['AL', 'AK', 'AZ',
                      'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA',
                      'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA',
                      'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT',
                      'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND',
                      'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN',
                      'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY']

    if $stateParams.errors
      Flash.create('danger', $stateParams.errors, 6000, {class: 'error'}, true)

    # For determining whether account is initializing
    # my payments or editing bank details
    # Currently, we do not want to "edit" bank info,
    # instead create a new bank info.
    if not $stateParams.account
      Account.getMe({with_stripe_data:true}).$promise.then (response) ->
        $scope.account = response

        # If editing bank info
        # Map all available info to determine more info needed if converting
        if $scope.account.stripe_account_id
          $scope.account_settings.account_type = $scope.account.account_info.business_type

          if $scope.account.account_info.business_type == "individual"
            $scope.account_settings.legal_first_name = $scope.account.account_info.individual.first_name
            $scope.account_settings.legal_last_name = $scope.account.account_info.individual.last_name

            if $scope.account.account_info.individual.ssn_last_4_provided
              $scope.account_settings.personal_tax_id = "000000000"
            
            if $scope.account.account_info.individual.dob.day
              $scope.account_settings.dob = "00000000"
          else
            $scope.account_settings.business_name = $scope.account.account_info.company.name

            $scope.account_settings.legal_first_name = $scope.account.account_info.persons[0].first_name
            $scope.account_settings.legal_last_name = $scope.account.account_info.persons[0].last_name

            if $scope.account.account_info.persons[0].dob.day
              $scope.account_settings.dob = "00000000"
            
            if $scope.account.account_info.persons[0].ssn_last_4_provided
              $scope.account_settings.personal_tax_id = "000000000"

            if $scope.account.account_info.company.tax_id_provided
              $scope.account_settings.business_tax_id = "00000000"

            if $scope.account.account_info.company.address
              $scope.account_settings.business_address_line1 = $scope.account.account_info.company.address.line1
              $scope.account_settings.business_address_line2 = $scope.account.account_info.company.address.line2
              $scope.account_settings.business_address_city = $scope.account.account_info.company.address.city
              $scope.account_settings.business_address_state = $scope.account.account_info.company.address.state
              $scope.account_settings.business_address_zip_code = $scope.account.account_info.company.address.postal_code
        else
          $scope.account_settings =
            account_type: 'individual'

    hotkeys.bindTo($scope).add
      combo: 'ctrl+8',
      description: 'Fill account settings with sample data'
      callback: () ->
        $scope.account_settings =
          account_type: "individual"
          legal_first_name: "joe"
          legal_last_name: "smith"
          dob: "01011990"
          personal_tax_id: "000000000"
          routing_number: "110000000"
          account_number: "000123456789"
          business_address_line1: "32 brook st"
          business_address_line2: "Unit 222"
          business_address_city: "Patchogue"
          business_address_state:  "NY"
          business_address_zip_code: "11772"

    $scope.open_modal = () ->
      $uibModal.open
        template: require("./whyModal.jade")
        windowClass: 'why-modal'
      .result.then () ->
        console.log('closed!')

    $scope.go_to_payment_info = () ->
      if !$scope.bank_info_form.$valid
        Flash.create('danger', 'Please enter required fields.', 6000, {class: 'error'}, true)
        return
      $state.go "root.dashboard.payments.payment_info", { account_settings: $scope.account_settings, account: $scope.account }

    $scope.set_state = (state) ->
      $scope.account_settings.business_address_state = state

    $scope.select_account_type = (account_type) ->
      $scope.account_settings.account_type = account_type



// WEBPACK FOOTER //
// ./components/dashboard/payments/signup/bank_account_info/bank_account_info.coffee